import React, { lazy, Suspense } from 'react';
import { Spin } from 'antd';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { useUserInfo } from './hooks';
import { useStateValue } from './providers/StateProvider';
import HomeAvisoPrivacidad from './pages/HomeAvisoPrivacidad';
import useTokenNotifGeneration from './hooks/useTokenNotifGeneration';

const ForgottenPassword = lazy(() => import('./pages/general/general/ForgottenPassword'));
const RecoverPassword = lazy(() => import('./pages/general/general/RecoverPassword'));
const Login = lazy(() => import('./pages/general/general/Login'));
const HomeEntidad = lazy(() => import('./pages/HomeEntidad'));
const HomePersonal = lazy(() => import('./pages/HomePersonal'));

const App = () => {
    const [{ lvl, avisoPrivacidad, verificado }] = useStateValue();
    useUserInfo();
    useTokenNotifGeneration();

    return (
        <Suspense fallback={(
            <div className="d-flex vh-100 align-items-center justify-content-center">
                <Spin />
            </div>
        )}
        >
            <Router>
                <Switch>
                    <Route path="/login">
                        <Login />
                    </Route>
                    <Route path="/recuperar">
                        <ForgottenPassword />
                    </Route>
                    <Route path="/recoverPassword">
                        <RecoverPassword />
                    </Route>
                    <Route path="/">
                        {!avisoPrivacidad && verificado === '3'
                            ? <HomeAvisoPrivacidad />
                            : {
                                0: <HomePersonal />,
                                1: <HomeEntidad />,
                            }[lvl] || <Login />}
                    </Route>
                </Switch>
            </Router>
        </Suspense>
    );
};
export default App;
